<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="bz-question">
        <span class="bz-bar bz-bar--xl"></span>
        <span class="bz-bar bz-bar--md"></span>
      </div>
      <div class="bz-firstbuzz">
        <span class="bz-cap">FIRST TO BUZZ</span>
        <div class="bz-nameplate">
          <span class="bz-avatar"></span>
          <span class="bz-name">Maya</span>
          <span class="material-symbols-rounded bz-bell">notifications_active</span>
        </div>
      </div>
      <div class="bz-others">
        <div v-for="i in 3" :key="i" class="bz-other">
          <span class="bz-other-avatar"></span>
          <span class="bz-bar bz-bar--sm"></span>
        </div>
      </div>
    </template>

    <template #audience>
      <span class="bz-phone-q"></span>
      <div class="bz-phone-stage">
        <button type="button" class="bz-phone-buzz" tabindex="-1">
          <span class="bz-phone-buzz-ring"></span>
          <span class="bz-phone-buzz-ring bz-phone-buzz-ring--2"></span>
          <span class="material-symbols-rounded">notifications_active</span>
          <span class="bz-phone-buzz-text">BUZZ!</span>
        </button>
      </div>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewBuzzerRound',
  components: { PreviewFrame },
  props: {
    slide: { type: Object as PropType<SlideType>, required: true },
  },
})
</script>

<style scoped lang="scss">
.bz-bar {
  display: block; height: 7px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.1);
}
.bz-bar--xl { width: 70%; height: 8px; background: rgba(15, 15, 20, 0.2); }
.bz-bar--md { width: 45%; }
.bz-bar--sm { width: 60%; height: 5px; }

.bz-question {
  display: flex; flex-direction: column; gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 20%, transparent);
}

.bz-firstbuzz {
  display: flex; flex-direction: column; gap: 6px;
}
.bz-cap {
  font-size: 9px; font-weight: 800;
  letter-spacing: 0.08em;
  color: rgba(15, 15, 20, 0.45);
}
.bz-nameplate {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 12px;
  background: var(--accent);
  border-radius: 10px;
  animation: bz-flash 4s ease-in-out infinite;
}
.bz-avatar {
  width: 28px; height: 28px;
  border-radius: 999px;
  background: white;
}
.bz-name {
  flex: 1;
  font-size: 16px; font-weight: 800;
  color: white;
}
.bz-bell {
  color: white;
  font-size: 22px;
  animation: bz-shake 4s ease-in-out infinite;
}

.bz-others {
  display: grid; gap: 4px;
  margin-top: 4px;
}
.bz-other {
  display: grid;
  grid-template-columns: 18px 1fr;
  align-items: center; gap: 8px;
  opacity: 0.5;
}
.bz-other-avatar {
  width: 18px; height: 18px;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.12);
}

/* ---- Audience phone ---- */
.bz-phone-q {
  display: block; height: 8px; border-radius: 999px;
  width: 70%; background: rgba(15, 15, 20, 0.18);
  margin-bottom: 4px;
}
.bz-phone-stage {
  flex: 1;
  display: grid; place-items: center;
  padding: 8px 0;
}
.bz-phone-buzz {
  position: relative;
  appearance: none; border: none;
  width: 100px; height: 100px;
  border-radius: 999px;
  background: var(--accent);
  color: white;
  display: grid; place-items: center;
  cursor: pointer;
  font-family: inherit;
  animation: bz-press 4s ease-in-out infinite;
}
.bz-phone-buzz .material-symbols-rounded {
  font-size: 32px;
  margin-bottom: 2px;
}
.bz-phone-buzz-text {
  position: absolute;
  bottom: 24px;
  font-size: 13px; font-weight: 800;
  letter-spacing: 0.06em;
}
.bz-phone-buzz-ring {
  position: absolute; inset: 0;
  border-radius: 999px;
  border: 2px solid var(--accent);
  animation: bz-ripple 4s ease-out infinite;
}
.bz-phone-buzz-ring--2 { animation-delay: 1.2s; }

@keyframes bz-flash {
  0%, 25%  { background: rgba(15, 15, 20, 0.1); }
  35%, 70% { background: var(--accent); }
  85%, 100% { background: rgba(15, 15, 20, 0.1); }
}
@keyframes bz-shake {
  0%, 30%  { transform: rotate(0); }
  35%      { transform: rotate(-12deg); }
  40%      { transform: rotate(12deg); }
  45%      { transform: rotate(-8deg); }
  50%, 100% { transform: rotate(0); }
}
@keyframes bz-press {
  0%, 25%  { transform: scale(1); }
  35%      { transform: scale(0.92); }
  45%, 100% { transform: scale(1); }
}
@keyframes bz-ripple {
  0%   { opacity: 1; transform: scale(1); }
  60%  { opacity: 0; transform: scale(1.5); }
  100% { opacity: 0; transform: scale(1.5); }
}

@media (prefers-reduced-motion: reduce) {
  .bz-nameplate, .bz-bell, .bz-phone-buzz, .bz-phone-buzz-ring { animation: none; }
}
</style>
